import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const containerWrapperFn = /* @__PURE__ */ createRecipe('container-wrapper', {
  "size": "default"
}, [])

const containerWrapperVariantMap = {
  "size": [
    "default",
    "narrow"
  ]
}

const containerWrapperVariantKeys = Object.keys(containerWrapperVariantMap)

export const containerWrapper = /* @__PURE__ */ Object.assign(memo(containerWrapperFn.recipeFn), {
  __recipe__: true,
  __name__: 'containerWrapper',
  __getCompoundVariantCss__: containerWrapperFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: containerWrapperVariantKeys,
  variantMap: containerWrapperVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, containerWrapperVariantKeys)
  },
  getVariantProps: containerWrapperFn.getVariantProps,
})